<template>
    <nav class="navbar">
        <div class="logo-area">
            <img src="@/assets/logo/logo.png" alt="公司LOGO" class="logo-img" />
            <span class="company-name">海南鼎昂建筑工程有限公司</span>
        </div>
        <button class="menu-toggle" @click="menuOpen = !menuOpen" aria-label="菜单" v-show="isMobile">
            <span :class="{ 'open': menuOpen }"></span>
            <span :class="{ 'open': menuOpen }"></span>
            <span :class="{ 'open': menuOpen }"></span>
        </button>
        <ul class="nav-links" :class="{ open: menuOpen }" @click="onMenuClick">
            <li><router-link to="/">网站首页</router-link></li>
            <li><router-link to="/about">关于我们</router-link></li>
            <li><router-link to="/project">工程案例</router-link></li>
            <li><router-link to="/contact">联系我们</router-link></li>
        </ul>
    </nav>
</template>

<script>
export default {
    name: 'Navbar',
    data() {
        return {
            menuOpen: false,
            isMobile: false
        };
    },
    mounted() {
        this.checkMobile();
        window.addEventListener('resize', this.checkMobile);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.checkMobile);
    },
    methods: {
        checkMobile() {
            this.isMobile = window.innerWidth <= 768;
            if (!this.isMobile) this.menuOpen = false;
        },
        onMenuClick(e) {
            // 点击菜单项自动收起
            if (this.isMobile && e.target.tagName === 'A') {
                this.menuOpen = false;
            }
        }
    }
};
</script>

<style scoped>
.navbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 48px;
    background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
    color: #222;
    height: 80px;
    box-shadow: 0 4px 20px rgba(30, 60, 120, 0.08);
    margin-bottom: 20px;
    position: relative;
    z-index: 10;
    border-bottom: 1px solid rgba(59, 130, 246, 0.1);
}

.logo-area {
    display: flex;
    align-items: center;
    gap: 16px;
}

.logo-img {
    height: 48px;
    width: 48px;
    object-fit: contain;
    border-radius: 10px;
    background: linear-gradient(135deg, #f7f8fa 0%, #e2e8f0 100%);
    box-shadow: 0 4px 12px rgba(30, 60, 120, 0.12);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.logo-img:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(30, 60, 120, 0.15);
}

.company-name {
    font-size: 24px;
    font-weight: 700;
    letter-spacing: 1.2px;
    color: #1a2a47;
    background: linear-gradient(135deg, #1a2a47 0%, #3b82f6 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

.menu-toggle {
    display: none;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 38px;
    height: 38px;
    background: none;
    border: none;
    cursor: pointer;
    margin-left: 12px;
    z-index: 20;
}

.menu-toggle span {
    display: block;
    width: 28px;
    height: 4px;
    margin: 3px 0;
    background: #1a2a47;
    border-radius: 2px;
    transition: 0.3s;
}

.menu-toggle span.open:nth-child(1) {
    transform: translateY(7px) rotate(45deg);
}

.menu-toggle span.open:nth-child(2) {
    opacity: 0;
}

.menu-toggle span.open:nth-child(3) {
    transform: translateY(-7px) rotate(-45deg);
}

.nav-links {
    display: flex;
    gap: 40px;
    list-style: none;
    transition: all 0.3s;
}

.nav-links a {
    color: #374151;
    text-decoration: none;
    font-size: 16px;
    font-weight: 600;
    padding: 12px 20px;
    border-radius: 8px;
    transition: all 0.3s ease;
    position: relative;
    letter-spacing: 0.5px;
}

.nav-links a::before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    width: 0;
    height: 3px;
    background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
    border-radius: 2px;
    transition: all 0.3s ease;
    transform: translateX(-50%);
}

.nav-links a:hover {
    color: #1a2a47;
    background: rgba(59, 130, 246, 0.05);
    transform: translateY(-2px);
}

.nav-links a:hover::before {
    width: 80%;
}

.nav-links a.router-link-exact-active {
    color: #3b82f6;
    background: rgba(59, 130, 246, 0.08);
    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15);
}

.nav-links a.router-link-exact-active::before {
    width: 80%;
}

@media (max-width: 768px) {
    .navbar {
        height: auto;
        padding: 12px 8px;
        margin-bottom: 10px;
        position: relative;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        min-height: 60px;
    }

    .logo-area {
        flex-shrink: 0;
        display: flex;
        align-items: center;
        gap: 8px;
        max-width: 70%;
    }

    .company-name {
        font-size: 16px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .menu-toggle {
        display: flex;
        margin-left: auto;
        position: relative;
        z-index: 25;
        margin-right: 10px;
        /* 新增：让按钮和右侧有间隙 */
    }

    .nav-links {
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        background: #fff;
        flex-direction: column;
        gap: 0;
        box-shadow: 0 4px 24px rgba(30, 60, 120, 0.10);
        padding: 0;
        z-index: 15;
        max-height: 0;
        overflow: hidden;
        opacity: 0;
        pointer-events: none;
        border-radius: 0 0 12px 12px;
        border: 1px solid rgba(59, 130, 246, 0.1);
    }

    .nav-links.open {
        max-height: 300px;
        opacity: 1;
        pointer-events: auto;
        padding: 8px 0 12px 0;
        transition: all 0.3s ease;
    }

    .nav-links li {
        width: 100%;
        text-align: left;
        padding: 0;
    }

    .nav-links a {
        display: block;
        width: 100%;
        font-size: 16px;
        padding: 12px 24px;
        border-bottom: 1px solid #f0f0f0;
    }

    .nav-links a:last-child {
        border-bottom: none;
    }
}

@media (max-width: 480px) {
    .navbar {
        padding: 8px 6px;
        min-height: 50px;
    }

    .logo-area {
        max-width: 65%;
        gap: 6px;
    }

    .company-name {
        font-size: 14px;
    }

    .logo-img {
        height: 36px;
        width: 36px;
    }

    .menu-toggle {
        width: 32px;
        height: 32px;
    }

    .menu-toggle span {
        width: 24px;
        height: 3px;
    }
}
</style>